<template>
<div>
  <section class="study">
    <h1 style="font-size: 13px" class="bold my-3 ">Danh sách ticket</h1>
    <div class=" table-responsive w-100" >
      <table class="table table-bordered ">
        <thead class="table-secondary">
        <tr align-items class=" " style="font-size: 13px">
          <th >Mã ticket</th>
          <th >Danh mục</th>
          <th >Bên xử lý</th>
          <th >Trạng thái</th>
          <th style="width: 600px">Tóm tắt phương án xử lý</th>
          <th >Thời gian tạo ticket</th>
        </tr>
        </thead>
        <tbody v-if="tickets.length == 0">
        <tr class="text-center">
          <td colspan="7">
            Không có dữ liệu
          </td>
        </tr>
        </tbody>
        <tbody>
        <tr v-for="(item, key) in tickets" :key="key" style="font-size: 13px">
          <td>{{ item.id }}</td>
          <td>{{ getCategory(item) }}</td>
          <td>{{ getProcessingDepartment(item) }}</td>
          <td>{{ STATUS[item.status] }}</td>
          <td>
            <span v-if="!item.ticket_detail"> - </span>
            <span v-else>
              <div class="tooltip-wrapper position-absolute">
                   {{ getSolutionSummary(item) }}
                <div class="tooltip-box">
                  <span v-if="item.ticket_detail && item.ticket_detail.solution_summary && item.ticket_detail.solution_summary.length > 80">
                    {{ item.ticket_detail.solution_summary }}
                  </span>
                  <span v-else>
                  {{ item.ticket_detail ? item.ticket_detail.solution_summary : '' }}
                  </span>
                </div>
              </div>
            </span>
          </td>
          <td>{{ formatDateTimeVietnam(item.created_at)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
</template>

<script>
import {GET_DATA_TICKET_CUSTOMER, GET_DATA_TICKET_CATEGORY} from "@/core/services/store/customer/customer.module";
import moment from "moment-timezone";

export default {
  name: "customer-care",
  data() {
    return {
      ticketWaiting: 0,
      ticketWorking: 0,
      ticketDone: 0,
      ticketCancel: 0,
      tickets: [],
      ARRAY_CATE_CHAM_SOC : {
        1: "Nghỉ liên tiếp",
        2: "Điểm thấp",
        3: "Không làm bài",
        4: "Chưa đóng tiền",
        5: "Đã đóng tiền",
        6: "Feedback thấp",
        7: "Nghỉ một buổi"
      },
      STATUS : {
        1: "Chờ xử lý",
        2: "Đã nhập giải pháp",
        3: "Đã hoàn thành",
        0: "Đã Hủy",
      },
        CHAM_SOC_HOC_VIEN : 1,
      array_cate : {
        1: "Nghỉ học",
        2: "Điểm thấp",
        3: "Không làm bài",
        4: "Chưa đóng tiền",
        5: "Đã đóng tiền",
        6: "Feedback thấp",
        7: "Nghỉ một buổi",
        8: "Nghỉ học",
        9: "Chăm sóc phụ huynh",
        11: "Không làm BTVN",
        12: "Tặng quà",
        13: 'Nhắc nhở bảo hành',
        14: 'Nghỉ 1 buổi không phép',
        15: 'Nghỉ buổi khai giảng',
        16: 'Chăm sóc học viên giữa khóa',
        17: 'Chăm sóc fail khóa',
        18: 'Feedback học viên',
        24: 'Chăm sóc học viên thi giữa khóa',
      },
      phong_ban_xu_ly_define: {
        1: 'TTHT',
        2: 'Tài chính',
        3: 'Nhân sự',
        4: 'SPNN',
        5: 'CNTT',
        6: 'Đối tác',
        7: 'STVT',
        8: 'Đào tạo',
        9: 'Brand',
        10: 'Digital',
        11: 'Marketing',
        12: 'R&D',
        13: 'Pháp lý',
        14: 'QLHV',
        15: 'CSVC',
        25: 'Bộ phận Callcenter',
      },
      categories: []
    }
  },
  mounted() {
    let idUser = this.$route.params.id
    this.getDataCareCustomer(idUser)
    this.getDataCategory()
  },
  methods: {
    getDataCareCustomer(idCustomer) {
      this.$store.dispatch(GET_DATA_TICKET_CUSTOMER,idCustomer).then((data) => {
        this.tickets = data.data.tickets;
        this.ticketWaiting = data.data.ticketWaiting;
        this.ticketWorking = data.data.ticketWorking;
        this.ticketDone = data.data.ticketDone;
        this.ticketCancel = data.data.ticketCancel;
      })
    },
    getDataCategory(idCustomer) {
      this.$store.dispatch(GET_DATA_TICKET_CATEGORY, {limit: 1000}).then((data) => {
        this.categories = data.data;

      })
    },
    findCategory(id)
    {
      let category = this.categories.find(item => item.id == id);
      if (!category)
      {
        return '';
      }
      return category.name;
    },
    showClassify(ticket) {
      let result = '';
      if (ticket.type_auto)
      {
        switch (ticket.type_auto) {
          case 2:
            return 'Chăm sóc giữa khóa';
          case 3:
            return 'Chăm sóc cuối khóa';
          case 4:
            return 'Chăm sóc sau buổi 4';
          default:
            return 'Chăm sóc sau buổi khai giảng';
        }
      }
      switch (ticket?.is_auto) {
        case 1:
          result = 'Chăm sóc học viên';
          break;
        case 2:
        case 3:
          result = 'Yêu cầu hỗ trợ';
          break;
      }
      return result
    },
    getCategory(item) {
      return this.array_cate[item.category_chamsoc] ?? this.findCategory(item.category_ticket_id);
    },

    getProcessingDepartment(item) {
      return this.phong_ban_xu_ly_define[item.phong_ban_xu_ly];
    },
    getSolutionSummary(item)
    {
      if (!item.ticket_detail.solution_summary)
      {
        return '';
      }
      return item.ticket_detail.solution_summary.length > 80 ? item.ticket_detail.solution_summary.substring(0, 80) + '...' : item.ticket_detail.solution_summary;
    },

    intendTime(typeTick ,time,ticket){;
        if(typeTick == this.CHAM_SOC_HOC_VIEN){
          return moment(time).add(48, 'hours').format('HH:mm DD/MM/YYYY')
        }else{
          return moment(time).add(ticket?.category_ticket?.hours, 'hours').format('HH:mm DD/MM/YYYY')
        }
    },
    formatDateTimeVietnam(date){
      return moment(date).format('HH:mm DD/MM/YYYY')
    }
  }
}
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-box {
  display: none;
  position: absolute;
  background: #333;
  color: #fff;
  padding: 6px 8px;
  border-radius: 4px;
  max-width: 1200px;
  white-space: normal;
  word-break: break-word;
  z-index: 100;
}

.tooltip-wrapper:hover .tooltip-box {
  display: block;
}

</style>
